module.exports = __webpack_public_path__ + "img/move-up.2d56743b.svg";